// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import DatabaseManagement from './DatabaseManagement'
import ProjectManagement from './ProjectManagement'
import { HomeWrapper } from './styles'

const Home = () => (
  <div className={'padding-1'}>
    <HomeWrapper className={'heading-font'}>
      <DatabaseManagement />
      <ProjectManagement />
    </HomeWrapper>
  </div>
)

export default Home
